<template>
  <RouterView />
  <MessageDetailModal />
  <ToastContainer />
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import MessageDetailModal from "./components/MessageDetailModal.vue";
import ToastContainer from "./components/ToastContainer.vue";
</script>
